module.exports = __WEBPACK_EXTERNAL_MODULE_3__;


//////////////////
// WEBPACK FOOTER
// external {"root":"Select","commonjs2":"react-select","commonjs":"react-select","amd":"react-select"}
// module id = 3
// module chunks = 0